// Module
var code = "<script>let $ctrl</script> <div class=\"flexWrapper__headerPanel\"> <organism-page-header-panel page-header-data=\"$ctrl.pageHeaderData\"></organism-page-header-panel> </div> <organism-email-wizard-wrapper product-code=\"$ctrl.productCode\"></organism-email-wizard-wrapper> ";
// Exports
module.exports = code;